import { render, staticRenderFns } from "./CustEdit.vue?vue&type=template&id=104a6a3c&scoped=true&"
import script from "./CustEdit.vue?vue&type=script&lang=js&"
export * from "./CustEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104a6a3c",
  null
  
)

export default component.exports